import { BarChartProcessor } from "./Core";

export class SingleEntityBarChartProcessor extends BarChartProcessor {
  public identity = "SingleEntityBarChartProcessor";
}
